import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const updateEmployeeNotification = (orgId: number, username: string, isOn: boolean) =>
  createGenericDispatcher({
    name: 'UPDATE_EMPLOYEE_NOTIFICATION',
    loadFunction: () =>
      Api.post(`/org/${orgId}/employees/notifications`, {
        body: JSON.stringify({
          username,
          isOn,
        }),
      }),
    args: { orgId, username, isOn },
  });
